












    import { Component, Vue ,Watch} from 'vue-property-decorator';  
    import { StoreState } from '../../../store';
    import { mapState, mapGetters } from 'vuex';  
    
    @Component({
        computed: {  
            ...mapState({ 
                'disabled': (state: StoreState) => !state.reports.currentFiltersHaveRun,
                'seacrtext_update': (state: StoreState) =>state.reports.searchtext,
                'callReports': (state: StoreState) => state.reports.callReports, 
                 searchtextclear: (state: StoreState) =>state.reports.searchtext_clear,
                 voicemailstatus: (state: StoreState) =>state.reports.voicedata_load,
            })
        },
    })

    export default class Search extends Vue { 
      
        data() {
            return {
                searchText: '',
                enterPressed:false,
                cust_disable:false
            };
        }
     
    
        @Watch('callReports')
        onChange() {
            //on run report clear input text and visible icon
            if((this as any).searchtextclear){ 
                  this.$data.searchText = '';
                  var x = document.getElementById("input_report");
                  x.style.display = "inline";
            }
		}

        searchRecords(evnt) {
            this.$data.cust_disable=true;
             this.$store.commit("SearchText_CLEAR",false);
             var self=this;
              if(this.$data.searchText !==""){
                this.$store.commit('SearchText_update', this.$data.searchText);
                this.$store.commit('UPDATE_CALL_REPORTS', { cdrs:[], total:0, monthindex:0,clear:true });
                this.$store.dispatch('getCallReports', {para:{ shouldContinue: false , Page:1, searchtext:this.$data.searchText}}).
                then((r) => {
               this.$data.cust_disable=false;
                 }).catch((r) => {
                    this.$data.cust_disable=false;
                });;
                self.$data.timeout_text=false;   
              }
              else{
                  this.clearSearch();
              }
        }
      

        clearSearch() {
            this.$data.searchText = '';
            this.$store.commit('SearchText_update', null);
            this.$store.commit('SET_BOOKMARK', { bookmark:'' });
            this.$store.commit('UPDATE_CALL_REPORTS', { cdrs:[], total:0, monthindex:0,clear:true });
            this.$store.dispatch('getCallReports', {para:{ shouldContinue: false , Page:1}})  .then((r) => { 
            this.$store.commit('SET_VOICEMAILS_REPO', []);
            this.$data.cust_disable=false;
             }).catch((r) => {
            this.$data.isLoading = false;
            this.$data.cust_disable=false;
            this.$store.commit('LOAD_MORE_BAR_VISIBLE', { isVisible: false,});
            });
        }

        search_inputclick()
        {
            var x = document.getElementById("input_report");
            //x.style.display = "none";
        }

        search_inputblur()
        {
            var x = document.getElementById("input_report");
            if(this.$data.searchText.length!=0){
           // x.style.display = "none";
            }
            else{
            x.style.display = "auto";//"inline";
            }
        }
            
        focusInput() 
        { 
            document.getElementById("input_searchr").focus(); 
            var x = document.getElementById("input_report");
           // x.style.display = "none";
        } 
    }
